import axios from "axios";
import {toAbsoluteApiUrl} from "../../_metronic/_helpers";

const API_URI = toAbsoluteApiUrl("/support");

export const report = data => axios.post(`${API_URI}/report`, data);
